import assert from 'shared/utils/assert'

import BackendAPIService from './BackendAPIService'
import type { ServiceParameters } from './commonTypes'
import type {
  IReturnLabel,
  IReturnLabelCreateSuborderItemsPayload,
} from './models/returnLabel'

const config = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

const API_VERSION = 'v1'

class ReturnLabelService extends BackendAPIService {
  constructor(props: ServiceParameters) {
    super(props)

    this.apiVersion = API_VERSION
  }

  getReturnLabelUrl(subOrderId?: string) {
    return `returnlabel/${this.apiVersion}/${this.tenantPath}/${subOrderId}`
  }

  async getReturnLabel(subOrderId: string): Promise<IReturnLabel> {
    assert(
      subOrderId,
      'ReturnLabelService.getReturnLabelDoc: please provide "subOrderId"'
    )

    const { data } = await this.get<IReturnLabel>(
      this.getReturnLabelUrl(subOrderId),
      config
    )

    return data
  }

  async createReturnLabel(
    subOrderId: string,
    suborderItems: IReturnLabelCreateSuborderItemsPayload[]
  ): Promise<unknown> {
    assert(
      subOrderId,
      'ReturnLabelService.getReturnLabelDoc: please provide "subOrderId"'
    )

    assert(
      suborderItems,
      'ReturnLabelService.getReturnLabelDoc: please provide "suborderItems"'
    )

    const { data } = await this.post(
      this.getReturnLabelUrl(subOrderId),
      { suborderItems },
      config
    )

    return data
  }
}

export default ReturnLabelService
